module.exports = "https://web-assets.ifttt.com/packs/media/service-previews/evernote-icon-daf2e747.png";